import { TLineSetupActions } from './line-setup.actions';
import { TLineSetUpState, TLineSetUpActionType } from './line-setup.models';

export const intialState: TLineSetUpState = {
  productionAreaWorkStations: null,
  floatingAreaFloorsForLocationDeletion: null,
  factoryLineWorkstationSummaryList: null,
  factoryLinesForShiftManagement: null,
};

export function lineSetupReducer(state = intialState, action: TLineSetupActions): TLineSetUpState {
  switch (action.type) {
    case TLineSetUpActionType.GetFactoryLineWorkstationSummaryListSuccess:
      return {
        ...state,
        factoryLineWorkstationSummaryList: action.res,
      };
    case TLineSetUpActionType.GetFactoryLineWorkstationSummaryList:
      return {
        ...state,
        factoryLineWorkstationSummaryList: null,
      };
    case TLineSetUpActionType.GetAllWorkstationsForProductionAreaSuccess:
      return {
        ...state,
        productionAreaWorkStations: action.res,
      };
    case TLineSetUpActionType.GetAllWorkstationsForProductionArea:
      return {
        ...state,
        productionAreaWorkStations: null,
      };
    case TLineSetUpActionType.GetFactoryLinesForShiftManagement:
      return {
        ...state,
        factoryLinesForShiftManagement: null,
      };
    case TLineSetUpActionType.GetFactoryLinesForShiftManagementSuccess:
      return {
        ...state,
        factoryLinesForShiftManagement: action.res,
      };
    default:
      return state;
  }
}
